export default "__VITE_ASSET__f4Kyqmi6__"